import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const EventFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  eventStats 
}) => {
  const eventTypeOptions = [
    { value: '', label: 'Todos os tipos' },
    { value: 'workshop', label: 'Workshops' },
    { value: 'promocao', label: 'Promoções' },
    { value: 'evento', label: 'Eventos' },
    { value: 'feira', label: 'Feiras' },
    { value: 'palestra', label: 'Palestras' }
  ];

  const categoryOptions = [
    { value: '', label: 'Todas as categorias' },
    { value: 'moda', label: 'Moda & Beleza' },
    { value: 'alimentacao', label: 'Alimentação' },
    { value: 'tecnologia', label: 'Tecnologia' },
    { value: 'saude', label: 'Saúde & Bem-estar' },
    { value: 'educacao', label: 'Educação' },
    { value: 'entretenimento', label: 'Entretenimento' },
    { value: 'servicos', label: 'Serviços' }
  ];

  const priceRangeOptions = [
    { value: '', label: 'Qualquer preço' },
    { value: 'free', label: 'Gratuito' },
    { value: '0-50', label: 'Até R$ 50' },
    { value: '50-100', label: 'R$ 50 - R$ 100' },
    { value: '100-200', label: 'R$ 100 - R$ 200' },
    { value: '200+', label: 'Acima de R$ 200' }
  ];

  const dateRangeOptions = [
    { value: '', label: 'Qualquer data' },
    { value: 'today', label: 'Hoje' },
    { value: 'tomorrow', label: 'Amanhã' },
    { value: 'this-week', label: 'Esta semana' },
    { value: 'next-week', label: 'Próxima semana' },
    { value: 'this-month', label: 'Este mês' },
    { value: 'next-month', label: 'Próximo mês' }
  ];

  const hasActiveFilters = Object.values(filters)?.some(value => 
    value && value !== '' && value !== 'all'
  );

  return (
    <div className="bg-card rounded-lg shadow-warm p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Filtros
          </h3>
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name="X" size={16} className="mr-1" />
            Limpar
          </Button>
        )}
      </div>
      <div className="space-y-4">
        {/* Search */}
        <div>
          <Input
            type="search"
            placeholder="Buscar eventos..."
            value={filters?.search || ''}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Event Type */}
        <div>
          <Select
            label="Tipo de Evento"
            options={eventTypeOptions}
            value={filters?.type || ''}
            onChange={(value) => onFilterChange('type', value)}
          />
        </div>

        {/* Category */}
        <div>
          <Select
            label="Categoria"
            options={categoryOptions}
            value={filters?.category || ''}
            onChange={(value) => onFilterChange('category', value)}
          />
        </div>

        {/* Date Range */}
        <div>
          <Select
            label="Período"
            options={dateRangeOptions}
            value={filters?.dateRange || ''}
            onChange={(value) => onFilterChange('dateRange', value)}
          />
        </div>

        {/* Price Range */}
        <div>
          <Select
            label="Faixa de Preço"
            options={priceRangeOptions}
            value={filters?.priceRange || ''}
            onChange={(value) => onFilterChange('priceRange', value)}
          />
        </div>

        {/* Additional Filters */}
        <div className="pt-4 border-t border-border">
          <h4 className="text-sm font-medium text-foreground mb-3">
            Filtros Adicionais
          </h4>
          
          <div className="space-y-3">
            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={filters?.availableOnly || false}
                onChange={(e) => onFilterChange('availableOnly', e?.target?.checked)}
                className="w-4 h-4 text-primary border-border rounded focus:ring-primary focus:ring-2"
              />
              <span className="text-sm text-foreground">
                Apenas com vagas disponíveis
              </span>
            </label>

            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={filters?.freeOnly || false}
                onChange={(e) => onFilterChange('freeOnly', e?.target?.checked)}
                className="w-4 h-4 text-primary border-border rounded focus:ring-primary focus:ring-2"
              />
              <span className="text-sm text-foreground">
                Apenas eventos gratuitos
              </span>
            </label>

            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={filters?.featuredOnly || false}
                onChange={(e) => onFilterChange('featuredOnly', e?.target?.checked)}
                className="w-4 h-4 text-primary border-border rounded focus:ring-primary focus:ring-2"
              />
              <span className="text-sm text-foreground">
                Apenas eventos em destaque
              </span>
            </label>
          </div>
        </div>
      </div>
      {/* Filter Stats */}
      {eventStats && (
        <div className="mt-6 pt-4 border-t border-border">
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-primary">
                {eventStats?.total}
              </div>
              <div className="text-xs text-muted-foreground">
                Total de Eventos
              </div>
            </div>
            <div>
              <div className="text-2xl font-bold text-accent">
                {eventStats?.thisWeek}
              </div>
              <div className="text-xs text-muted-foreground">
                Esta Semana
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventFilters;